import { ApolloClient, from, HttpLink, InMemoryCache, ServerError } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

import { environment } from 'utils/environment.utils';

const httpLink = new HttpLink({ uri: `${process.env.REACT_APP_API_URL}/graphql` });

const requestMiddleware = onError(({ networkError }) => {
    const serverError = networkError as ServerError;
    if (serverError.statusCode === 401) window.location.href = `${environment.APP_URL}/entrar?redirectTo=${window.location.pathname}`;
    if (serverError.statusCode === 500) window.location.href = `${environment.APP_URL}/home/cursos`;
});

const authMiddleware = setContext((_, { headers }) => {
    const token = (document.cookie.split('hub$user$payload=')[1] || '').split(';')[0];
    return {
        headers: {
            ...headers,
            Authorization: token ? `Bearer ${token}` : '',
        },
    };
});

export const graphqlApi = new ApolloClient({
    cache: new InMemoryCache(),
    link: from([authMiddleware, requestMiddleware, httpLink]),
    connectToDevTools: true,
});
